import { InfiniteData } from '@tanstack/react-query'

import { SearchOffersDto } from '@wwt/entities/api/search-response'
import { OffersAndMetadata } from '@wwt/entities/search-response'

export const searchKeys = {
	base: ['search'] as const,
	get: (searchRequest: SearchOffersDto | null) =>
		[...searchKeys.base, 'get', searchRequest] as const
}

export interface SearchTypes {
	get: InfiniteData<OffersAndMetadata>
}

export interface SearchKeys {
	get: ReturnType<typeof searchKeys.get>
}
